import React from 'react';
import {
  Box,
  Heading,
  Link,
  chakra,
  Center,
  Image,
  Text,
  Divider,
  HStack,
  Tag,
  Wrap,
  WrapItem,
  SpaceProps,
  useColorModeValue,
  Button,
  Flex,
} from '@chakra-ui/react';

export function ContactUs() {
  return (
    <div>
    <chakra.p fontWeight={'bold'} fontSize={33}>
      Contact Us
    </chakra.p>

    <chakra.p
      lineHeight={1.4}
      letterSpacing={'.1px'}
      fontSize={'20px'} mt={5}>
      To contact us please reach out to us at <a href="mailto:info@testmymind.net" style={{textDecoration:"underline", color:"lightblue"}}>info@testmymind.net</a>
    </chakra.p>
    </div>
  )
}
